const LENGTH_NIBBLE_LOCATION = 20;

export const parse = (uuid: string): number => {
  uuid = uuid.replace('-', '');

  const length = parseInt(uuid.substr(LENGTH_NIBBLE_LOCATION, 1), 16);
  const hexId = uuid.slice(-length);
  return parseInt(hexId, 16);
};
